<template>
  <footer>
    <b-container fluid>
      <div class="footer-content">
        <div class="footer-left">
          <span class="copyright">
            © {{ fecha }} <a href="https://systemico.net" target="_blank" rel="noopener noreferrer" class="company-link">Systemico</a>. {{ translation[lang].brand }} {{ translation[lang].rights }}
          </span>
        </div>
        <div class="footer-right">
          <a href="https://systemico.net/help" target="_blank" rel="noopener noreferrer">{{ translation[lang].help }}</a>
          <a href="https://systemico.net/privacy" target="_blank" rel="noopener noreferrer">{{ translation[lang].privacy }}</a>
          <a href="https://systemico.net/terms" target="_blank" rel="noopener noreferrer">{{ translation[lang].terms }}</a>
          <a href="https://systemico.net/contact" target="_blank" rel="noopener noreferrer">{{ translation[lang].contact }}</a>
        </div>
      </div>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'footerC',
  props: {
    lang: {
      type: String,
      default: 'EN'
    }
  },
  data () {
    return {
      fecha: '',
      translation: {
        EN: {
          brand: 'A SystemicoSoftware S.A.S. brand.',
          rights: 'All rights reserved.',
          help: 'Help',
          privacy: 'Privacy',
          terms: 'Terms',
          contact: 'Contact'
        },
        ES: {
          brand: 'Una marca SystemicoSoftware S.A.S.',
          rights: 'Todos los derechos reservados.',
          help: 'Ayuda',
          privacy: 'Privacidad',
          terms: 'Términos',
          contact: 'Contacto'
        },
        PT: {
          brand: 'Uma marca SystemicoSoftware S.A.S.',
          rights: 'Todos os direitos reservados.',
          help: 'Ajuda',
          privacy: 'Privacidade',
          terms: 'Termos',
          contact: 'Contato'
        },
        FR: {
          brand: 'Une marque SystemicoSoftware S.A.S.',
          rights: 'Tous droits réservés.',
          help: 'Aide',
          privacy: 'Confidentialité',
          terms: 'Conditions',
          contact: 'Contact'
        }
      }
    }
  },

  mounted () {
    this.fecha = new Date().getFullYear()
  }
}
</script>

<style lang="scss" scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  backdrop-filter: none;
  z-index: 1000;
  padding: 15px 5px;
  border-top: none;
  .footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 auto;
    padding: 0 30px;
  }
  .footer-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .footer-right {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .company-name {
    font-weight: bold;
  }
  .copyright {
    font-size: 12px;
    color: #6c757d;
    .company-link {
      font-weight: bold;
      color: inherit;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  a {
    color: #222222;
    font-size: 12px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  footer {
    .footer-content {
      flex-direction: column;
      text-align: center;
      gap: 10px;
    }
    .footer-left {
      flex-direction: column;
      gap: 5px;
    }
  }
}
</style>
